import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ModalComponent } from '../../../modal/modal.component';
import { ConfirmComponent } from '../../../modal/confirm.component';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { InstallationReceivedPluginService } from './received.service';
import { Subscription } from 'rxjs';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';

@Component({
    selector: 'installation-received-edit',
    templateUrl: './received-edit.component.html',
    standalone: false
})
export class InstallationReceivedEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  plugin: any;
  editForm: UntypedFormGroup;

  public documentTypes: any[];
  public statuses: any[];
  public currentItem: any;

  private receivedValueToRemove: number;
  private sub = new Subscription();

  @ViewChild('documentTypesModal', { static: true }) documentTypesModal: ModalComponent;
  @ViewChild('statusesModal', { static: true }) statusesModal: ModalComponent;
  @ViewChild('receivedValueDeleteConfirm', { static: true }) receivedValueDeleteConfirm: ConfirmComponent;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationReceivedPluginService,
    private fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['receivedValues'];
  }

  ngOnInit(): void {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  public save(model: any) {
    this.processing = true;
    this.pluginService
      .updateReceivedValues(this.inspectionId, this.pointId, this.pluginId, model.receivedValues)
      .subscribe((res) => {
        this.processing = false;
        this.goToBack();
      });
  }

  public add() {
    const control = <UntypedFormArray>this.editForm.controls['receivedValues'];
    control.push(this.initReceived());
  }

  public remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['receivedValues'];
    control.removeAt(this.receivedValueToRemove);
  }

  public onClose(e: any) {
    this.currentItem.controls['DocumentType'].markAsTouched();
    this.currentItem.controls['Status'].markAsTouched();
  }

  public selectDocumentTypesMenu(item: any) {
    const selectedIndex =
      this.currentItem.controls['DocumentType'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['DocumentType'].setValue(selectedIndex);
  }

  public selectStatusesMenu(item: any) {
    const selectedIndex = this.currentItem.controls['Status'].value === item.selectedIndex ? '' : item.selectedIndex;
    this.currentItem.controls['Status'].setValue(selectedIndex);
  }

  public openDocumentTypesSelector(selectedIndex: number, i: number): void {
    this.openSelector(
      this.documentTypesModal,
      this.documentTypes,
      selectedIndex || selectedIndex === 0 ? selectedIndex : -1
    );
    const control = <UntypedFormArray>this.editForm.controls['receivedValues'];
    this.currentItem = control.controls[i];
  }

  public openStatusSelector(selectedIndex: number, i: number): void {
    this.openSelector(this.statusesModal, this.statuses, selectedIndex || selectedIndex === 0 ? selectedIndex : -1);
    const control = <UntypedFormArray>this.editForm.controls['receivedValues'];
    this.currentItem = control.controls[i];
  }

  public openReceivedValueDeleteConfirm(i: number) {
    this.receivedValueDeleteConfirm.open();
    this.receivedValueToRemove = i;
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  private initData() {
    this.documentTypes = _.orderBy(this.pluginService.getDocumentTypes(), ['label']);
    this.statuses = _.orderBy(this.pluginService.getStatuses(), ['label']);
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  private initForm() {
    this.editForm = this.fb.group({
      receivedValues: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['receivedValues'];
    _.forEach(this.plugin.config.ReceivedValues, (el) => {
      control.push(this.initReceived(el));
    });
  }

  private initReceived(el?: any) {
    return this.fb.group({
      DocumentType: new UntypedFormControl(el?.DocumentType ?? ''),
      Status: new UntypedFormControl(el && el.Status ? parseInt(el.Status) : 0),
      Comment: new UntypedFormControl(el?.Comment ?? '')
    });
  }
}
